var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboard-page bold tablec" }, [
    _c(
      "div",
      { staticClass: "d-flex flex-row" },
      [
        _c(
          "Widget",
          {
            staticClass: "shares-widget w-100",
            attrs: {
              title: "Behaviours",
              fetchingData: _vm.isReceiving || _vm.isDeleting
            }
          },
          [
            _c("div", { staticClass: "display-flex mt-4" }, [
              _c("b", { staticClass: "mr-2" }, [_vm._v("Legend: ")]),
              _vm._v(" "),
              _c("div", { staticClass: "mr-3" }, [
                _c("i", { staticClass: "fa fa-circle text-success" }),
                _vm._v(" "),
                _c("span", [_vm._v(" Public & country specific")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mr-3" }, [
                _c("i", { staticClass: "fa fa-circle text-inverse" }),
                _vm._v(" "),
                _c("span", [_vm._v(" Not public & country specific")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mr-3" }, [
                _c("span", {
                  staticClass: "glyphicon glyphicon-globe pb-1",
                  staticStyle: { color: "#3abf94" }
                }),
                _vm._v(" "),
                _c("span", [_vm._v(" Public & global")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mr-3" }, [
                _c("span", {
                  staticClass: "glyphicon glyphicon-globe pb-1",
                  staticStyle: { color: "#495057" }
                }),
                _vm._v(" "),
                _c("span", [_vm._v(" Not public & global")])
              ])
            ]),
            _vm._v(" "),
            _vm.hasAdminRole()
              ? _c(
                  "b-button",
                  {
                    staticClass: "mb-3 mt-3",
                    attrs: { variant: "success" },
                    on: {
                      click: function($event) {
                        return _vm.createNewBehaviour()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                    Add new behaviour\n                "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.behaviours.length == 0
              ? _c("h6", { staticClass: "p-2" }, [
                  _vm._v(" No behaviours added yet.")
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "list-group list-group-lg" },
              _vm._l(_vm.behaviours, function(behaviour) {
                return _c(
                  "div",
                  {
                    key: behaviour.id,
                    staticClass: "list-group-item display-flex",
                    staticStyle: { "align-items": "center" },
                    attrs: { href: "#" }
                  },
                  [
                    _c("div", { staticStyle: { width: "70%" } }, [
                      _c("h4", {}, [
                        behaviour.global
                          ? _c("span", {
                              staticClass: "glyphicon glyphicon-globe pb-1",
                              style: {
                                color: behaviour.public ? "#3abf94" : "#495057"
                              }
                            })
                          : _c("i", {
                              staticClass: "fa fa-circle",
                              class:
                                "text-" +
                                (behaviour.public ? "success" : "inverse")
                            }),
                        _vm._v(
                          "\n                                " +
                            _vm._s(behaviour.title) +
                            "\n                            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("h6", [_vm._v(_vm._s(behaviour.description))]),
                      _vm._v(" "),
                      _c("small", { staticClass: "text-muted" }, [
                        _vm._v(
                          _vm._s(
                            _vm.formatDate(
                              behaviour.startDate,
                              behaviour.timezone
                            )
                          ) +
                            " - " +
                            _vm._s(
                              _vm.formatDate(
                                behaviour.endDate,
                                behaviour.timezone
                              )
                            )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "ml-auto" }, [
                      _c("span", {
                        staticClass:
                          "glyphicon glyphicon-eye-open icon-button p-1",
                        on: {
                          click: function($event) {
                            return _vm.$router.push(
                              "/app/content/behaviours-detail/" + behaviour.id
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.hasAdminRole(behaviour.global)
                        ? _c("span", {
                            staticClass:
                              "glyphicon glyphicon-pencil icon-button p-1",
                            on: {
                              click: function($event) {
                                return _vm.$router.push(
                                  "/app/content/behaviours/" + behaviour.id
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      behaviour.public && _vm.hasAdminRole(behaviour.global)
                        ? _c("span", {
                            staticClass:
                              "fa fa-check-circle-o icon-button p-1 text-success",
                            attrs: {
                              id: "popoverDeleteVersion_" + behaviour.id
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !behaviour.public && _vm.hasAdminRole(behaviour.global)
                        ? _c("span", {
                            staticClass: "fa fa-check-circle-o icon-button p-1",
                            attrs: {
                              id: "popoverDeleteVersion_" + behaviour.id
                            }
                          })
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-popover",
                      {
                        staticClass: "popover-danger",
                        attrs: {
                          triggers: "click",
                          target: "popoverDeleteVersion_" + behaviour.id,
                          show: _vm.popovers[behaviour.id],
                          placement: "top"
                        },
                        on: {
                          "update:show": function($event) {
                            return _vm.$set(_vm.popovers, behaviour.id, $event)
                          }
                        }
                      },
                      [
                        _c("template", { slot: "title" }, [
                          behaviour.public
                            ? _c("div", { staticClass: "px-5" }, [
                                _vm._v(
                                  "Are you sure you want to disable this behaviour?"
                                )
                              ])
                            : _c("div", { staticClass: "px-5" }, [
                                _vm._v(
                                  "Are you sure you want to enable this behaviour?"
                                )
                              ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "px-5 d-flex justify-content-center" },
                          [
                            _c(
                              "b-button-toolbar",
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: { variant: "success", size: "xs" },
                                    on: {
                                      click: function() {
                                        _vm.toggleBehaviourPublic({
                                          id: behaviour.id,
                                          public: !behaviour.public,
                                          $toasted: _vm.$toasted
                                        })
                                        _vm.closePopover(behaviour.id)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        Yes\n                                    "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    attrs: { variant: "danger", size: "xs" },
                                    on: {
                                      click: function($event) {
                                        return _vm.closePopover(behaviour.id)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        No\n                                    "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      2
                    )
                  ],
                  1
                )
              }),
              0
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }